<div *ngIf="businessKey != null">
    <div class="title" id="ServicesBuilding" style="filter: brightness(50%)">
        {{ serviceNames != null ? serviceNames : 'Your Service(s)' }} Is/Are Building
    </div>
    <div class="subtitle smaller">
        {{ serviceNames != null ? serviceNames : 'Your Service(s)' }} Is/Are being created<br />Details are below.
    </div>
    <div class="row center" id="ServicesBulkSaveCurrentTask">
        <div [ngClass]="stepStyle" class="building services"></div>
        <div [ngClass]="{ open: stepStyle.includes('step') }" class="buildSteps" id="currentStatus">
            {{ message }}
        </div>
    </div>
    <div class="content" id="ServicesBulkSaveAllTasks">
        <div *ngIf="servicesStatus.length > 0">
            <div *ngFor="let status of servicesStatus; let index = index" class="statusRow">
                <div class="bubble severityInfo"></div>
                <div class="statusText" id="servicesStatus_task_{{ index }}">
                    {{ status['task'] }}
                </div>
                <div class="statusText second" id="servicesStatus_status_{{ index }}">
                    {{ status['status'] }}
                </div>
            </div>
        </div>
    </div>
</div>
